import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createDeletePersonaCommand } from '../../../api/commands/factory/createPersonaCommands';
import { Activity, StorymapState, Subtask, Task } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DeletePersona extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeletePersona';

    public constructor(public id: string) {
        super(DeletePersona.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: DeletePersona): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createDeletePersonaCommand(action),
    });
};

const reducer = (state: StorymapState, action: DeletePersona): void => {
    state.personas = state.personas.filter((x) => x.id != action.id);

    deletePersonaFrom(state.activities, action);
    deletePersonaFrom(state.tasks, action);
    deletePersonaFrom(state.subtasks, action);
};

const deletePersonaFrom = (cards: (Activity | Task | Subtask)[], action: DeletePersona) => {
    const cardsToDeleteFrom = cards.filter((x) => x.personaIds.includes(action.id));
    cardsToDeleteFrom.forEach((card) => {
        card.personaIds = card.personaIds.filter((x) => x != action.id);
    });
};

//@ts-ignore
registerMiddleware(DeletePersona.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeletePersona.ACTION_TYPE, reducer);
